import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { getTheme, getVars } from '../../global/utils'
import Tip from './Tip'

const FieldWrapper = styled.div`
  margin-bottom: ${getTheme('marginBottom', 'l')};
  label {
    display: block;
  }
  .label {
    display: block;
    line-height: 1;
    color: ${getTheme('textColor', 'alt')};
    margin-bottom: ${getTheme('spacer', 'xs')};
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
  }

  input {
    color: ${getTheme('textColor', 'base')};
    border: 2px solid ${getTheme('black', '_800')};
    font-size: ${props =>
      (props.size === 'xsmall' && getTheme('fontSize', 'caption')) ||
      (props.size === 'small' && getTheme('fontSize', 'note')) ||
      (props.size === 'medium' && getTheme('fontSize', 'body')) ||
      (props.size === 'large' && getTheme('fontSize', 'title')) ||
      getTheme('fontSize', 'body')};
    border-radius: ${props =>
      (props.size === 'xsmall' && getTheme('radius', 'xs')) ||
      (props.size === 'small' && getTheme('radius', 's')) ||
      (props.size === 'medium' && getTheme('radius', 'm')) ||
      (props.size === 'large' && getTheme('radius', 'l')) ||
      getTheme('radius', 'm')};
    padding: ${props =>
        (props.size === 'xsmall' && getTheme('padding', 'verticalXS')) ||
        (props.size === 'small' && getTheme('padding', 'verticalS')) ||
        (props.size === 'medium' && getTheme('padding', 'verticalM')) ||
        (props.size === 'large' && getTheme('padding', 'verticalL')) ||
        getTheme('padding', 'verticalM')}
      ${props =>
        (props.size === 'xsmall' && getTheme('padding', 'horizontalXS')) ||
        (props.size === 'small' && getTheme('padding', 'horizontalS')) ||
        (props.size === 'medium' && getTheme('padding', 'horizontalM')) ||
        (props.size === 'large' && getTheme('padding', 'horizontalL')) ||
        getTheme('padding', 'horizontalM')};
    height: ${props =>
      (props.size === 'xsmall' && getTheme('height', 'xs')) ||
      (props.size === 'small' && getTheme('height', 's')) ||
      (props.size === 'medium' && getTheme('height', 'm')) ||
      (props.size === 'large' && getTheme('height', 'l')) ||
      getTheme('height', 'm')};
  }

  input::placeholder {
    color: ${getTheme('textColor', 'altLight')};
  }
  input:hover:not([disabled]) {
    border-color: ${getTheme('black', '_600')};
  }

  input:focus {
    outline: 0;
    box-shadow: 0 0 0 4px ${rgba(getVars('bg', 'active'), 0.25)};
  }

  ${props =>
    props.inputBlock &&
    css`
      input {
        width: 100%;
      }
    `};

  ${props =>
    props.error &&
    css`
      input {
        border-color: ${getTheme('textColor', 'errorLight')};
      }
      input:hover {
        border-color: ${getTheme('textColor', 'error')};
      }
    `};

  ${props =>
    props.disabled &&
    css`
      opacity: 0.25;
      input:hover {
        cursor: not-allowed;
      }
    `};
  ${props =>
    props.inline &&
    css`
      .label {
        display: inline-block;
        margin-right: ${getTheme('spacer', 's')};
      }
    `};
`

class InputField extends Component {
  render() {
    const hasTip = this.props.tip
    const success = this.props.success
    const error = this.props.error
    let tipWrapper = ''
    let inputWrapper = ''
    if (hasTip) {
      tipWrapper = <Tip>{this.props.tip}</Tip>
    }
    if (success) {
      tipWrapper = <Tip success>{this.props.success}</Tip>
    }
    if (error) {
      tipWrapper = <Tip error>{this.props.error}</Tip>
    }

    inputWrapper = (
      <input
        name={this.props.name}
        type={this.props.type}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        autoFocus={this.props.autoFocus}
        onBlur={this.props.onBlur}
        onClick={this.props.onClick}
        onChange={this.props.onChange}
        maxLength={this.props.maxLength}
        value={this.props.value}
        autoCapitalize="none"
      />
    )

    return (
      <FieldWrapper
        size={this.props.size}
        inputBlock={this.props.inputBlock}
        inline={this.props.inline}
        error={this.props.error}
        success={this.props.success}
        disabled={this.props.disabled}
      >
        <label>
          <span className="label">{this.props.label}</span>
          {inputWrapper}
        </label>
        {tipWrapper}
      </FieldWrapper>
    )
  }
}

export default InputField



// WEBPACK FOOTER //
// ./src/components/forms/InputField.js